import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AddressNumberOneDirective } from './addressNumber.directive';
import { AddressNumberTwoDirective } from './addressNumberSecondPart.directive';
import { BlockCopyPasteDirective } from './block-copy-paste.directive';
import { BlockEmoticonsDirective } from './block-emoticons.directive';
import { DdiCodeDirective } from './ddi.directive';
import { KeyUpDebounceDirective } from './key-up-debounce.directive';
import { LettersAndNumbersDirective } from './letters-and-numbers.directive';
import { LettersOnlyDirective } from './letters-only.directive';
import { NumbersOnlyDirective } from './numbers-only.directive';

@NgModule({
	declarations: [BlockCopyPasteDirective, KeyUpDebounceDirective, BlockEmoticonsDirective, LettersOnlyDirective, LettersAndNumbersDirective, AddressNumberOneDirective, AddressNumberTwoDirective, DdiCodeDirective, NumbersOnlyDirective],
	imports: [CommonModule],
	exports: [BlockCopyPasteDirective, KeyUpDebounceDirective, BlockEmoticonsDirective, LettersOnlyDirective, LettersAndNumbersDirective, AddressNumberOneDirective, AddressNumberTwoDirective, DdiCodeDirective, NumbersOnlyDirective],
})
export class DirectiveModule {}
